import { useState } from 'react';
import { Link } from 'react-router-dom';
import { EventType } from '@azure/msal-browser';
import { msalInstance } from '.';
import { DrawerContainer, DrawerContainerShell } from './components/DrawerContainer';
import { Dashboard } from './home/Dashboard';
import { SettingsNavigation } from './components/settings/SettingsNavigation';
import KitAdminList from './pages/kit/Kit_AdminList';
import KitImport from './pages/kit/Kit_Import';
import ManageLab from './pages/labs/Lab_Manage';
import LabList from './pages/labs/Lab_List';
import MergeDuplicateLab from './pages/labs/Duplicate_Lab';
import ManagePipet from './pages/pipet/Pipet_Manage';
import PipetList from './pages/pipet/Pipet_List';
import ManageSubmittedKit from './pages/submittedKit/SubmittedKit_Manage';
import SubmittedKitList from './pages/submittedKit/SubmittedKit_List';
import ManageSubmittedKitRun from './pages/submittedKitRun/SubmittedKitRun_Manage';
import SubmittedKitRunList from './pages/submittedKitRun/SubmittedKitRun_List';
import { Routes, Route } from "react-router-dom";
import { AuthenticatedTemplate } from '@azure/msal-react';
import OperatorList from './pages/operator/Operator_List';
import ManageOperator from './pages/operator/Operator_Manage';
import { PvsContextProvider, themes } from './components/PvsContextProvider';
import { ThemeSwitcherProvider } from 'react-css-theme-switcher';
import { OnboardingMain } from './components/Onboarding/Onboarding_Main';
import { HangfireFrame } from './components/HangfireFrame';
import { SerialPage } from './pages/serial/SerialPage';
import { AutoLogout } from './components/AutoLogout';
import { FAQPage } from './pages/FAQ/FAQ';
import LegacyReportList from './pages/legacyReports/LegacyReport_List';
import ReportList from './pages/reports/Report_List';
import ViewReport from './pages/reports/View_Report';
import { KitStatus } from './models/kitStatus';

import SubmittedKitAuditList from './pages/audit/SubmittedKit_AuditList';
import SubmittedKitRunAuditList from './pages/audit/SubmittedKitRun_AuditList';
import PipetAuditList from './pages/audit/Pipet_AuditList';
import ReportAuditList from './pages/audit/Report_AuditList';
import AppUserAuditList from './pages/audit/AppUser_AuditList';
import AppUserLabAuditList from './pages/audit/AppUserLab_AuditList';
import CommentAuditList from './pages/audit/Comment_AuditList';
import KitAuditList from './pages/audit/Kit_AuditList';
import KitTrackingAuditList from './pages/audit/KitTracking_AuditList';
import LabAuditList from './pages/audit/Lab_AuditList';
import LabInviteAuditList from './pages/audit/LabInvite_AuditList';
import OperatorAuditList from './pages/audit/Operator_AuditList';
import { DecommisionedAnnouncement, MaintenceAnnouncement } from './components/Announcement';

interface AppProps {
    handleLogOut: Function,
    children?: React.ReactNode
}

const App = (props: AppProps) => {
    const [hasAccount, setHasAccount] = useState(msalInstance.getActiveAccount() !== null);

    msalInstance.addEventCallback((event: any) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
            setHasAccount(true);
        }
    });

    return (<>{hasAccount ?
        <AutoLogout handleLogOut={props.handleLogOut}>
            <PvsContextProvider>
                <DrawerContainer handleLogOut={props.handleLogOut}>
                    <Routes>
                        <Route path="onboarding" element={
                            <AuthenticatedTemplate>
                                <OnboardingMain></OnboardingMain>
                            </AuthenticatedTemplate>
                        }></Route>

                        <Route path="redirect" element={
                            <AuthenticatedTemplate>
                                <Dashboard></Dashboard>
                            </AuthenticatedTemplate>
                        }></Route>
                        <Route path="home" element={
                            <AuthenticatedTemplate>
                                <Dashboard></Dashboard>
                            </AuthenticatedTemplate>
                        }></Route>
                        <Route path="settings" element={
                            <AuthenticatedTemplate>
                                <SettingsNavigation></SettingsNavigation>
                            </AuthenticatedTemplate>
                        }></Route>

                        <Route path="serial" element={
                            <AuthenticatedTemplate>
                                <SerialPage showMessages={true} handleCompletedMessage={(testValue: string) => { console.log("Test Functionality: ", testValue) }}></SerialPage>
                            </AuthenticatedTemplate>
                        }></Route>

                        <Route path="barcode-list" element={
                            <AuthenticatedTemplate>
                                <KitAdminList></KitAdminList>
                            </AuthenticatedTemplate>
                        }></Route>
                        <Route path="barcode-import" element={
                            <AuthenticatedTemplate>
                                <KitImport key={Date.now()}></KitImport>
                            </AuthenticatedTemplate>
                        }></Route>

                        <Route path="lab-list" element={
                            <AuthenticatedTemplate>
                                <LabList ></LabList>
                            </AuthenticatedTemplate>
                        }></Route>
                        <Route path="lab-manage" element={
                            <AuthenticatedTemplate>
                                <ManageLab key={Date.now()}></ManageLab>
                            </AuthenticatedTemplate>
                        }></Route>
                        <Route path="lab-manage/:LabId" element={
                            <AuthenticatedTemplate>
                                <ManageLab></ManageLab>
                            </AuthenticatedTemplate>
                        }></Route>

                        <Route path="merge-duplicate-lab" element={
                            <AuthenticatedTemplate>
                                <MergeDuplicateLab></MergeDuplicateLab>
                            </AuthenticatedTemplate>
                        }></Route>

                        <Route path="operator-list" element={
                            <AuthenticatedTemplate>
                                <OperatorList></OperatorList>
                            </AuthenticatedTemplate>
                        }></Route>
                        <Route path="operator-manage" element={
                            <AuthenticatedTemplate>
                                <ManageOperator key={Date.now()}></ManageOperator>
                            </AuthenticatedTemplate>
                        }></Route>
                        <Route path="operator-manage/:OperatorId" element={
                            <AuthenticatedTemplate>
                                <ManageOperator></ManageOperator>
                            </AuthenticatedTemplate>
                        }></Route>

                        <Route path="pipet-list" element={
                            <AuthenticatedTemplate>
                                <PipetList></PipetList>
                            </AuthenticatedTemplate>
                        }></Route>
                        <Route path="pipet-manage" element={
                            <AuthenticatedTemplate>
                                <ManagePipet key={Date.now()}></ManagePipet>
                            </AuthenticatedTemplate>
                        }></Route>
                        <Route path="pipet-manage/:PipetId" element={
                            <AuthenticatedTemplate>
                                <ManagePipet></ManagePipet>
                            </AuthenticatedTemplate>
                        }></Route>

                        <Route path="legacy-report-list" element={
                            <AuthenticatedTemplate>
                                <LegacyReportList></LegacyReportList>
                            </AuthenticatedTemplate>
                        }></Route>

                        <Route path="report-list" element={
                            <AuthenticatedTemplate>
                                <ReportList></ReportList>
                            </AuthenticatedTemplate>
                        }></Route>
                        <Route path="view-report/:ReportId" element={
                            <AuthenticatedTemplate>
                                <ViewReport></ViewReport>
                            </AuthenticatedTemplate>
                        }></Route>

                        <Route path="submitted-kit-list" element={
                            <AuthenticatedTemplate>
                                <SubmittedKitList></SubmittedKitList>
                            </AuthenticatedTemplate>
                        }></Route>
                        <Route path="submitted-kit-list-processing" element={
                            <AuthenticatedTemplate>
                                <SubmittedKitList kitStatusFilter={KitStatus.Processing} key={"submitted-kit-list-processing"}></SubmittedKitList>
                            </AuthenticatedTemplate>
                        }></Route>
                        <Route path="submitted-kit-list-review" element={
                            <AuthenticatedTemplate>
                                <SubmittedKitList kitStatusFilter={KitStatus.Review} key={"submitted-kit-list-review"}></SubmittedKitList>
                            </AuthenticatedTemplate>
                        }></Route>
                        <Route path="submitted-kit-list-completed" element={
                            <AuthenticatedTemplate>
                                <SubmittedKitList kitStatusFilter={KitStatus.Completed} key={"submitted-kit-list-completed"}></SubmittedKitList>
                            </AuthenticatedTemplate>
                        }></Route>
                        <Route path="submitted-kit-manage" element={
                            <AuthenticatedTemplate>
                                <ManageSubmittedKit key={Date.now()}></ManageSubmittedKit>
                            </AuthenticatedTemplate>
                        }></Route>
                        <Route path="submitted-kit-manage/:SubmittedKitId" element={
                            <AuthenticatedTemplate>
                                <ManageSubmittedKit></ManageSubmittedKit>
                            </AuthenticatedTemplate>
                        }></Route>

                        <Route path="submitted-kit-run-list" element={
                            <AuthenticatedTemplate>
                                <SubmittedKitRunList></SubmittedKitRunList>
                            </AuthenticatedTemplate>
                        }></Route>
                        <Route path="submitted-kit-run-manage/:SubmittedKitRunId" element={
                            <AuthenticatedTemplate>
                                <ManageSubmittedKitRun></ManageSubmittedKitRun>
                            </AuthenticatedTemplate>
                        }></Route>

                        <Route path="faq" element={
                            <AuthenticatedTemplate>
                                <FAQPage></FAQPage>
                            </AuthenticatedTemplate>
                        }></Route>
                        <Route path="help" element={
                            <FAQPage></FAQPage>
                        }></Route>

                        <Route path="hangfire" element={
                            <AuthenticatedTemplate>
                                <HangfireFrame></HangfireFrame>
                            </AuthenticatedTemplate>
                        }></Route>

                        {/* Start Audit List Pages*/}
                        <Route path="app-user-audit-list" element={
                            <AuthenticatedTemplate>
                                <AppUserAuditList></AppUserAuditList>
                            </AuthenticatedTemplate>}>
                        </Route>
                        <Route path="app-user-lab-audit-list" element={
                            <AuthenticatedTemplate>
                                <AppUserLabAuditList></AppUserLabAuditList>
                            </AuthenticatedTemplate>}>
                        </Route>
                        <Route path="comment-audit-list" element={
                            <AuthenticatedTemplate>
                                <CommentAuditList></CommentAuditList>
                            </AuthenticatedTemplate>}>
                        </Route>
                        <Route path="barcode-audit-list" element={
                            <AuthenticatedTemplate>
                                <KitAuditList></KitAuditList>
                            </AuthenticatedTemplate>}>
                        </Route>
                        <Route path="kit-tracking-audit-list" element={
                            <AuthenticatedTemplate>
                                <KitTrackingAuditList></KitTrackingAuditList>
                            </AuthenticatedTemplate>}>
                        </Route>
                        <Route path="lab-audit-list" element={
                            <AuthenticatedTemplate>
                                <LabAuditList></LabAuditList>
                            </AuthenticatedTemplate>}>
                        </Route>
                        <Route path="lab-invite-audit-list" element={
                            <AuthenticatedTemplate>
                                <LabInviteAuditList></LabInviteAuditList>
                            </AuthenticatedTemplate>}>
                        </Route>
                        <Route path="operator-audit-list" element={
                            <AuthenticatedTemplate>
                                <OperatorAuditList></OperatorAuditList>
                            </AuthenticatedTemplate>}>
                        </Route>
                        <Route path="pipet-audit-list" element={
                            <AuthenticatedTemplate>
                                <PipetAuditList></PipetAuditList>
                            </AuthenticatedTemplate>}>
                        </Route>
                        <Route path="report-audit-list" element={
                            <AuthenticatedTemplate>
                                <ReportAuditList></ReportAuditList>
                            </AuthenticatedTemplate>}>
                        </Route>
                        <Route path="submitted-kit-run-audit-list" element={
                            <AuthenticatedTemplate>
                                <SubmittedKitRunAuditList></SubmittedKitRunAuditList>
                            </AuthenticatedTemplate>}>
                        </Route>
                        <Route path="submitted-kit-audit-list" element={
                            <AuthenticatedTemplate>
                                <SubmittedKitAuditList></SubmittedKitAuditList>
                            </AuthenticatedTemplate>}>
                        </Route>
                        {/* End Audit List Pages*/}

                        <Route path="" element={
                            <AuthenticatedTemplate>
                                <Dashboard></Dashboard>
                            </AuthenticatedTemplate>
                        }></Route>
                    </Routes>
                </DrawerContainer>
            </PvsContextProvider>
        </AutoLogout>
        : <DrawerContainerShell appUser={null}>
            <ThemeSwitcherProvider defaultTheme="light" themeMap={themes}>
                <Routes>
                    <Route path="" element={
                        <>
                            <span className="streck-primary" style={{ color: "white", width: "100%", display: "inline-block", textAlign: "center", fontSize: "16pt", padding: "8px" }}>
                                For help with signing up, signing in, and onboarding please visit our <Link to="/help">FAQs page</Link>.
                            </span>
                            <span style={{ zIndex: 1, position: 'absolute', top: '200px', left: '50%', marginRight: '-50%', transform: 'translate(-50%, -50%)' }}>
                                {MaintenceAnnouncement()}
                                {DecommisionedAnnouncement()}
                            </span>
                            <img id="landingImage" src={require("./assets/PVSLandingPage.png")} style={{ zIndex: 0, height: "calc(100vh - 152px)", objectFit: "contain", position: "relative" }} />
                        </>
                    }></Route>
                    <Route path="help" element={
                        <FAQPage></FAQPage>
                    }></Route>
                </Routes>
            </ThemeSwitcherProvider>
        </DrawerContainerShell>}
    </>
    );
};

export default App;

